export default __webpack_public_path__ + "static/media/wwd_icon_3.eaaa6d50.png";